import React from 'react';

const IconHome = ({ color, width, height }) => {
  return (
    <svg fill={color} height={height} width={width} viewBox="0 0 24 24">
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

export default IconHome;



// WEBPACK FOOTER //
// ./src/IconHome.js